import { instance as axios } from "../axios";
import JWT from 'jsonwebtoken';

const TABLE = '/acao/';

// initial state
const state = {
    data: [
        {
            id_distrito: '1',
            nome: 'Açores'
        },
        {
            id_distrito: '2',
            nome: 'Aveiro'
        },
        {
            id_distrito: '3',
            nome: 'Beja'
        },
        {
            id_distrito: '4',
            nome: 'Braga'
        },
        {
            id_distrito: '5',
            nome: 'Bragança'
        },
        {
            id_distrito: '6',
            nome: 'Castelo Branco'
        },
        {
            id_distrito: '7',
            nome: 'Coimbra'
        },
        {
            id_distrito: '8',
            nome: 'Évora'
        },
        {
            id_distrito: '9',
            nome: 'Faro'
        },
        {
            id_distrito: '10',
            nome: 'Guarda'
        },
        {
            id_distrito: '11',
            nome: 'Leiria'
        },
        {
            id_distrito: '12',
            nome: 'Lisboa'
        },
        {
            id_distrito: '13',
            nome: 'Madeira'
        },
        {
            id_distrito: '14',
            nome: 'Portalegre'
        },
        {
            id_distrito: '15',
            nome: 'Porto'
        },
        {
            id_distrito: '16',
            nome: 'Santarém'
        },
        {
            id_distrito: '17',
            nome: 'Setúbal'
        },
        {
            id_distrito: '18',
            nome: 'Viana do Castelo'
        },
        {
            id_distrito: '19',
            nome: 'Vila Real'
        },
        {
            id_distrito: '20',
            nome: 'Viseu'
        },
        {
            id_distrito: '21',
            nome: 'Nacional'
        },
        {
            id_distrito: '22',
            nome: 'Fora de Portugal'
        }
    ]
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data;
    },
    getById: (state) => (id) => {
        if(!id) return;
        return state.data.find((el)=>{ return el.id_distrito == id})
    }
}

const actions = {}

const mutations = {}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/distritos.js